<template>
  <div>
    <Form
      ref="editModel"
      :model="editModel"
      :rules="edit_ruleValidate"
      :label-width="100"
      inline
    >
    <FormItem label="用户名称" prop="userName">
        <Input class="w-250" v-model="editModel.userName"></Input>
      </FormItem>
      <FormItem label="医院名称" prop="hospitalName">
        <Input class="w-250" v-model="editModel.hospitalName"></Input>
      </FormItem>
      <FormItem label="秘钥" prop="secret">
        <Input class="w-250" v-model="editModel.secret"></Input>
      </FormItem>
      <FormItem label="服务名称" prop="serverName">
        <Input class="w-250" v-model="editModel.serverName"></Input>
      </FormItem>
      <FormItem label="hospitalId" prop="hospitalId">
        <Input class="w-250" v-model="editModel.hospitalId"></Input>
      </FormItem>
      <FormItem label="accessId" prop="accessId">
        <Input class="w-250" v-model="editModel.accessId"></Input>
      </FormItem>
      <FormItem label="achiveApi" prop="achiveApi">
        <Input class="w-250" v-model="editModel.achiveApi"></Input>
      </FormItem>
      <FormItem label="dImageUrl" prop="dImageUrl">
        <Input class="w-250" v-model="editModel.dImageUrl"></Input>
      </FormItem>
      <FormItem label="deleteFlag" prop="deleteFlag">
        <Input class="w-250" v-model="editModel.deleteFlag"></Input>
      </FormItem>
      <FormItem label="eUnityAddress" prop="eUnityAddress">
        <Input class="w-250" v-model="editModel.eUnityAddress"></Input>
      </FormItem>
      <FormItem label="eUnityUser" prop="eUnityUser">
        <Input class="w-250" v-model="editModel.eUnityUser"></Input>
      </FormItem>
      <FormItem label="maxDays" prop="maxDays">
        <Input class="w-250" v-model="editModel.maxDays"></Input>
      </FormItem>
      <FormItem label="privateKey" prop="privateKey">
        <Input class="w-250" v-model="editModel.privateKey"></Input>
      </FormItem>
      <FormItem label="productCode" prop="productCode">
        <Input class="w-250" v-model="editModel.productCode"></Input>
      </FormItem>
      <FormItem label="providerId" prop="providerId">
        <Input class="w-250" v-model="editModel.providerId"></Input>
      </FormItem>
      <FormItem label="publicKey" prop="publicKey">
        <Input class="w-250" v-model="editModel.publicKey"></Input>
      </FormItem>
      <FormItem label="rasType" prop="rasType">
        <Input class="w-250" v-model="editModel.rasType"></Input>
      </FormItem>
    </Form>
    <div class="text-center modal-foter">
      <Button class="mr-5" @click="returnBack">取 消</Button>
      <Button type="success" @click="handleSubmit('editModel')"
        >确 定</Button
      >
    </div>
  </div>
</template>
<script>
export default {
  props: ["editModelTemp"],
  components: {},
  data: function () {
    return {
      organParentName: "",
      editModel: {},
      edit_ruleValidate: {
        
      },
    };
  },

  created: function () {
    this.$common.getDictionaryByCode("skey").then((data) => {
      this.SecretTypeSelect = data;
    });
    this.editModel = this.editModelTemp;
  },

  methods: {
    returnBack: function () {
      this.$emit("close");
    },

    handleSubmit: function (from) {
      this.$refs[from].validate((valid) => {
        if (valid) {
          this.$api.post("secret/update", this.editModel).then((rsp) => {
            if (rsp != false) {
              this.$Message.success("更新成功");
              this.returnBack();
              this.resetData();
              this.$emit("loadData");
            }
          });
        }
      });
    },
    Generate() {
      var Current = this;
      this.$api.post("secret/GenerateKey").then((rsp) => {
        if (rsp.statusCode == "200") {
          Current.editModel.secretID = rsp.data.privateKey;
          Current.editModel.secretKey = rsp.data.publicKey;
        } else {
          this.$Message.success("添加成功");
          return;
        }
      });
    },
    resetData() {
      this.$refs["editModel"].resetFields();
    },
  },
};
</script>
<style scoped>
</style>